import moment from 'moment-timezone'
const now = (new Date()).getTime()

/**
 * Timezones list
 *
 * @type {Zone[]}
 */
export const timezones = moment.tz.names()
  .map(name => moment.tz.zone(name))
  .sort((a, b) => b.utcOffset(now) - a.utcOffset(now))
  .map((timezone, index) => {
    timezone.index = index

    timezone.offset = -timezone.utcOffset(+new Date()) / 60

    timezone.label = timezone.offset === 0
      ? `(UTC) ${timezone.name}`
      : `(UTC${timezone.offset > 0 ? '+' : ''}${timezone.offset}) ${timezone.name}`

    return timezone
  })

/**
 * Get timezone index for provided timezone name
 *
 * @param {String} text
 * @param {Boolean} exact looking for the exact name
 */
export const getTimezoneIndex = (name, exact = true) => {
  const exp = exact
    ? RegExp(`^${name}$`, 'i')
    : RegExp(`.*${name}.*`, 'i')

  const index = timezones.findIndex(timezone => exp.test(timezone.name))

  return index !== -1
    ? index
    : undefined
}

/**
 * Get default value for timezone
 *
 * 1. LocalStorage
 * 2. Guess from Browser
 * 3. UTC
 *
 * @params {Object} { name: timezone name }
 * @return {Integer} timezoneIndex
 */
export const getDefaultTimezoneIndex = () => {
  const timezoneFromLocalStorage = localStorage.getItem('timezone') || false

  return getTimezoneIndex(timezoneFromLocalStorage) ||
    getTimezoneIndex(moment.tz.guess(true)) ||
    getTimezoneIndex('UTC')
}

/**
 * Datetime format for humans
 */
export const datetimeForHumans = 'YYYY-MM-DD hh:mmA'

/**
 * Date format for inputs
 */
export const dateForInputs = 'YYYY-MM-DD'

/**
 * Time format for inputs
 */
export const timeForInputs = 'HH:mm'

/**
 * Check if a specific date in the past
 *
 * @param {String|null} date
 */
export const isPastDate = (date) => {
  return date && moment.utc().diff(moment.utc(date)) > 0
}
